import CurrencyExchangeController from './currency-exchange-controller';

export default function CurrencyExchange() {
    return {
        templateUrl: 'currency-exchange/currency-exchange-table.html',
        controller: CurrencyExchangeController,
        controllerAs: 'currencyExchangeVM',
        bindToController: true,
        replace: true,
        restrict: 'EA',
        scope: {
            supportedProviders: '=',
            currencyTranslations: '=',
            availableCurrencies: '='
        }
    };
}
